const TAGS_INPUT_PLACEHOLDER = "";
const TAGS_INPUT_WIDTH = 50;

const TAG_CELL_MARGIN_TOP = 4;
const TAG_CELL_MARGIN_LEFT = 4;
const TAG_CROSS_MARGIN_LEFT = 8;
const TAG_PADDING_TOP = 4;
const TAG_PADDING_RIGHT = 8;
const TAG_PADDING_BOTTOM = 4;
const TAG_PADDING_LEFT = 8;
const TAG_MARGIN_RIGHT = 6;
const TAG_MARGIN_BOTTOM = 6;

const TAG_CROSS_WIDTH = 9.92;
const TAG_CROSS_HEIGHT = 15;

export {
  TAG_CELL_MARGIN_LEFT,
  TAG_CELL_MARGIN_TOP,
  TAG_CROSS_HEIGHT,
  TAG_CROSS_MARGIN_LEFT,
  TAG_CROSS_WIDTH,
  TAG_MARGIN_BOTTOM,
  TAG_MARGIN_RIGHT,
  TAG_PADDING_BOTTOM,
  TAG_PADDING_LEFT,
  TAG_PADDING_RIGHT,
  TAG_PADDING_TOP,
  TAGS_INPUT_PLACEHOLDER,
  TAGS_INPUT_WIDTH
};
